module.exports = __webpack_public_path__ + "img/arrow-down.05948df4.svg";